<template>
  <div class="video-detail">
    <!-- 顶部返回栏 -->
    <div class="header-bar" :style="{ paddingTop: safeTop + 'px', height: headerHeight + 'px' }">
      <div class="header-title" @click="goBack">
        <img class="logo" src="@/static/icon/leftB.png" alt="" />
        <span>{{ $t('common.back') }}</span>
      </div>
    </div>

    <!-- 视频区域 -->
     <div
        class="video-container"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
      >
      <div
        v-for="(item, idx) in displaySwiperList"
        :key="idx"
        class="swiper-item"
        v-show="Math.abs(displayIndex - idx) === 0"
        :style="{ width: windowWidth + 'px', height: windowHeight + 'px' }"
      >
        <div class="video-wrapper">
          <video
            ref="videoPlayer"
            class="video-player"
            :style="{ width: windowWidth + 'px', height: windowHeight + 'px' }"
            playsinline
            webkit-playsinline
            x5-video-player-type="h5-page"
            @ended="ended"
            @error="onVideoError"
            @click="togglePlay"
            @timeupdate="onTimeUpdate"
            @loadedmetadata="onLoadedMetadata"
            @waiting="onVideoWaiting"
            @pause="onVideoPause"
            @playing="onVideoPlaying"
            @canplay="onVideoCanPlay"
            @seeking="onVideoSeeking"
            @seeked="onVideoSeeked"
          ></video>

          <div
            v-if="idx === displayIndex && activeSubtitleText"
            class="subtitle-overlay"
          >
            {{ activeSubtitleText }}
          </div>

          <!-- 中间播放按钮：未播放且未加载中时显示 -->
          <div
            v-if="isqp && !isPlaying && !isBuffering"
            class="play-state-layer"
          >
            <div class="play-state-btn" @click.stop="togglePlay">
              <div class="play-icon"></div>
            </div>
          </div>

          <!-- 中间加载画面 -->
          <div v-if="isqp && isBuffering" class="loading-layer">
            <div class="loading-spinner"></div>
          </div>

          <!-- 底部进度条 -->
          <div v-if="isqp" class="video-controls" @click.stop>
            <div class="time-text">
              <span>{{ formatTime(currentTime) }}</span>
              <span>{{ formatTime(duration) }}</span>
            </div>
            <input
              class="progress-bar"
              type="range"
              min="0"
              :max="duration || 0"
              step="0.1"
              :value="currentTime"
              @input="onSeekInput"
              @change="onSeekChange"
            />
          </div>
        </div>

        <!-- 右侧悬浮按钮 -->
        <div v-if="isqp" class="userInfo">
          <div class="btn-right" @click="goUser">
            <img src="@/static/video/mine.png" class="img-icon" alt="" />
            <span class="btn-text">{{ $t('video.myPage') }}</span>
          </div>
          <div class="btn-right" @click="toggleFavorite">
            <img
              :src="info.record == 1
                ? require('@/static/video/favorite.png')
                : require('@/static/video/unfavorite.png')"
              class="img-icon"
              alt=""
            />
            <span class="btn-text">{{ $t('video.favorite') }}</span>
          </div>
          <div class="btn-right" @click="viewEpisode">
            <img src="@/static/video/episodes.png" class="img-icon" alt="" />
            <span class="btn-text">{{ $t('video.episodes') }}</span>
          </div>
        </div>

        <!-- 底部剧名 -->
        <div v-if="isqp" class="contentcd">
          <span class="words" @click="viewEpisode">{{ $t('video.episodeUnit', { num: item?.weigh || currentEpisodeNum }) }}</span>
          <img style="width:8px; height:10px" src="@/static/video/right.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 选集弹窗 -->
    <div v-if="episodePopupVisible" class="popup-mask" @click="episodePopupVisible = false">
        <div class="popup-content episode" @click.stop>
            <div class="popup-header episode-header">
            <span>{{ $t('video.playingEpisode', { num: currentEpisodeNum }) }}</span>
            <img src="@/static/video/downw.png" @click="episodePopupVisible = false" />
            </div>

            <div class="video-info episode-video-info no-cover">
            <div class="info-text">
                <div class="title">{{ info.name }}</div>
                <div class="wanji">{{ info.wanji }}</div>
            </div>
            </div>

            <div class="episode-list">
            <div
                v-for="(ep, epIdx) in computedOriginList"
                :key="ep._id || ep.id || epIdx"
                class="episode-item"
                :class="{
                active: originIndex === epIdx,
                locked: ep.pays == 1
                }"
                @click="selectEpisode(epIdx, ep.pays)"
            >
                <span>{{ $t('video.episodeUnit', { num: ep.weigh }) }}</span>
                <img
                v-if="ep.pays == 1"
                src="@/static/video/lock.png"
                class="lock-icon"
                alt=""
                />
            </div>
            </div>
        </div>
    </div>

    <!-- 购买弹窗 -->
    <div v-if="buyPopupVisible" class="popup-mask" @click="buyPopupVisible = false">
        <div class="popup-content buy" @click.stop>
            <div class="popup-header buy-header">
              <button class="buy-close" type="button" @click="buyPopupVisible = false">×</button>
            </div>

            <div class="balance-panel">
              <div class="balance-left">
                <div class="balance-icon">
                  <img src="@/static/video/koin.png" alt="" />
                </div>
                <div>
                  <span>{{ $t('video.myBalance') }}</span>
                  <strong>{{ formatBalance(userBalance) }}</strong>
                </div>
              </div>
              <button class="recharge-button" type="button" :disabled="activeMember" @click="goRecharge">
                {{ packageMode === 'recharge' ? $t('video.subscriptionPrivilege') : $t('video.rechargeNow') }}
              </button>
            </div>

            <div class="popup-section-title">
              {{ packageMode === 'recharge' ? $t('recharge.selectAmount') : $t('video.chooseSubscriptionPackage') }}
            </div>

            <div v-if="popupSubscriptionPlans.length" class="popup-subscription-grid">
              <button
                v-for="plan in popupSubscriptionPlans"
                :key="plan.id || plan.sku_id"
                class="popup-subscription-card"
                :class="{
                  disabled: isSubscriptionPlanDisabled(plan),
                  current: isCurrentSubscriptionPlan(plan),
                  selected: selectedSubscriptionId === plan.id
                }"
                type="button"
                @click="choosePopupSubscriptionPlan(plan)"
              >
                <span class="plan-check"></span>
                <span v-if="plan.default == 1" class="popup-subscription-badge">{{ $t('video.popular') }}</span>
                <strong>
                  {{ packageMode === 'recharge' ? plan.title : formatBillingCycle(plan.billing_cycle) }}
                  <img v-if="packageMode === 'recharge'" class="popup-coin-icon" src="@/static/video/koin.png" alt="" />
                </strong>
                <span class="popup-subscription-price">
                  {{ packageMode === 'recharge' ? (getCurrencyText(plan.currency_symbol) || formatSubscriptionPrice(plan.amount)) : formatSubscriptionPrice(plan.web_price) }}
                </span>
                <span v-if="isCurrentSubscriptionPlan(plan)" class="popup-subscription-status">{{ $t('subscription.currentPlan') }}</span>
              </button>
            </div>

            <div class="buy-actions">
              <div class="balance-buy-row">
                <div>
                  <span>{{ $t('video.unlockCost') }}</span>
                  <strong>
                    <img src="@/static/video/koin.png" alt="" />
                    {{ selectedUnlockAmount }}
                  </strong>
                </div>
                <button type="button" @click="buySelectedUnlockOption">
                  {{ $t('video.balancePurchase') }}
                </button>
              </div>
              <button class="subscription-action-button" type="button" :disabled="activeMember" @click="handlePackagePrimaryAction">
                {{ packageMode === 'recharge' ? $t('recharge.btn') : $t('video.subscriptionPrivilege') }}
              </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js';
import { videoInfo, historyView } from "@/apis/video";
import { tFavorite, userRInfo } from "@/apis/user";
import { Toast } from 'vant';
import { buy, buyVip, rechargeTemp, getVipPackages } from "@/apis/recharge"
import {unlockEpisode} from "@/apis/payment"
import { isActiveMember } from "@/utils/member"
export default {
  name: 'VideoDetail',
  data() {
    return {
      hls: null,
      videoElement: null,
      currentTime: 0,
      duration: 0,
      isSeeking: false,
      isPlaying: false,
      isBuffering: false,
      isDragSeeking: false,
      activeSubtitleCues: [],
      activeSubtitleText: '',
      subtitleFrameId: null,
      subtitleLoadToken: 0,

      isqp: true,
      episodePopupVisible: false,
      buyPopupVisible: false,

      vid: 0,
      mid: 0,
      info: {},
      originList: [],
      displaySwiperList: [],
      displayIndex: 0,
      originIndex: 0,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      safeTop: 0,
      headerHeight: 44,

      price: 0,
      page: 1,

      touchStartY: 0,
      touchMoveY: 0,
      swipeThreshold: 60,
      isSwitchingEpisode: false,

      isBuying: false,
      pendingBuyIndex: null,
      packageMode: 'vip',
      vipPackages: [],
      rechargePackages: [],
      selectedSubscriptionId: null,
      isSubscribing: false,
      vipPackagesLoaded: false,
      rechargePackagesLoaded: false,
      userMoney: 0,
      isRefreshingUserBalance: false
    };
  },
  computed: {
    computedOriginList() {
      return this.originList || [];
    },
    currentEpisodeNum() {
      return this.originList[this.originIndex]?.weigh || this.originIndex + 1;
    },
    userBalance() {
      return Number(this.userMoney || 0);
    },
    activeMember() {
      const userInfo = this.$getUserInfo ? this.$getUserInfo() : null;
      return isActiveMember(userInfo);
    },
    unlockOptions() {
      const episodePrice = Number(this.price || 0);
      return [{
        type: 'single',
        count: 1,
        amount: episodePrice,
        label: this.$t('video.buySingle'),
        popular: true
      }];
    },
    selectedUnlockOption() {
      return this.unlockOptions.find(option => option.popular) || this.unlockOptions[0] || null;
    },
    selectedUnlockAmount() {
      return this.selectedUnlockOption ? this.selectedUnlockOption.amount : Number(this.price || 0);
    },
    subscriptionPlans() {
      const source = this.packageMode === 'recharge' ? this.rechargePackages : this.vipPackages;
      return (source || [])
        .slice()
        .sort((a, b) => Number(a.sort || 0) - Number(b.sort || 0))
        .map(item => {
          const durationDays = Number(item.duration_days || item.number_days || 0) + Number(item.give_number_days || 0);
          return {
            ...item,
            amount: Number(item.amount || 0),
            billing_cycle: item.billing_cycle || item.title || item.product_name || '',
            duration_days: durationDays,
            web_price: item.web_price || item.amount || 0
          };
        });
    },
    popupSubscriptionPlans() {
      return this.subscriptionPlans;
    },
    selectedPlan() {
      return this.subscriptionPlans.find(plan => plan.id === this.selectedSubscriptionId) || null;
    },
    hasPrevEpisode() {
      return this.originIndex > 0;
    },
    hasNextEpisode() {
      return this.originIndex < this.originList.length - 1;
    }
  },

  mounted() {
    this.safeTop = document.documentElement.clientTop || 0;
    this.headerHeight = 44 + this.safeTop;
    this.syncUserBalanceFromStorage();
    this.refreshUserBalance();
    this.initFromRoute();
    this.Recommend();
    window.addEventListener('resize', this.handleResize);
  },

  activated() {
    this.syncUserBalanceFromStorage();
    this.refreshUserBalance();
    this.reloadByRoute();
    window.addEventListener('resize', this.handleResize);
  },

  deactivated() {
    this.destroyPlayer();
    window.removeEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    this.destroyPlayer();
    window.removeEventListener('resize', this.handleResize);
  },

  beforeRouteLeave(to, from, next) {
    this.destroyPlayer();
    window.removeEventListener('resize', this.handleResize);
    next();
  },

  methods: {
    onTouchStart(e) {
      if (!e.touches || !e.touches.length) return;
      this.touchStartY = e.touches[0].clientY;
      this.touchMoveY = this.touchStartY;
    },

    onTouchMove(e) {
      if (!e.touches || !e.touches.length) return;
      this.touchMoveY = e.touches[0].clientY;
    },

    onTouchEnd() {
      const deltaY = this.touchMoveY - this.touchStartY;

      if (Math.abs(deltaY) < this.swipeThreshold) {
        this.touchStartY = 0;
        this.touchMoveY = 0;
        return;
      }

      if (deltaY < 0) {
        this.switchToNext();
      }

      if (deltaY > 0) {
        this.switchToPrev();
      }

      this.touchStartY = 0;
      this.touchMoveY = 0;
    },

    switchToPrev() {
      if (!this.hasPrevEpisode || this.isSwitchingEpisode) return;

      this.isSwitchingEpisode = true;
      this.originIndex = this.originIndex - 1;
      this.displayIndex = (this.displayIndex + 2) % 3;

      this.initSwiperData(this.originIndex);
      this.updateRouteQuery();

      this.$nextTick(() => {
        this.isSwitchingEpisode = false;
      });
    },

    switchToNext() {
      if (!this.hasNextEpisode || this.isSwitchingEpisode) return;

      this.isSwitchingEpisode = true;
      this.originIndex = this.originIndex + 1;
      this.displayIndex = (this.displayIndex + 1) % 3;

      this.initSwiperData(this.originIndex);
      this.updateRouteQuery();

      this.$nextTick(() => {
        this.isSwitchingEpisode = false;
      });
    },

    updateRouteQuery() {
      const current = this.originList[this.originIndex];
      const pageIndex = current?.pageIndex ?? this.originIndex;
      const newUrl = `${this.$route.path}?vid=${this.vid}&mid=${this.mid}&originIndex=${pageIndex}`;
      window.history.replaceState(null, '', newUrl);
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },

    initFromRoute() {
      const query = this.$route.query;
      this.vid = query.vid ? (isNaN(Number(query.vid)) ? query.vid : Number(query.vid)) : 0;
      this.mid = query.mid || 0;
      if (query.originIndex !== undefined) {
        this.originIndex = Number(query.originIndex) || 0;
      }
    },
    
    reloadByRoute() {
      // 清理旧播放和旧状态
      this.destroyPlayer();

      this.currentTime = 0;
      this.duration = 0;
      this.isSeeking = false;
      this.isPlaying = false;
      this.isBuffering = false;
      this.isDragSeeking = false;
      this.revokeActiveSubtitleUrl();
      this.isSwitchingEpisode = false;

      this.episodePopupVisible = false;
      this.buyPopupVisible = false;
      this.isBuying = false;

      // 关键：重新请求新视频时，分页要重置
      this.page = 1;

      // 关键：列表、索引要重置，避免旧数据残留
      this.info = {};
      this.originList = [];
      this.displaySwiperList = [];
      this.displayIndex = 0;
      this.originIndex = 0;

      // 从新 query 读取 vid / mid / originIndex
      this.initFromRoute();

      // 重新请求接口
      this.Recommend();
    },

    async Recommend(retry = 0) {
      let uid = 0;
      let token = '';
      const userInfo = this.$getUserInfo();

      if (userInfo) {
        uid = userInfo.id;
        token = userInfo.token;
      }

      try {
        const res = await videoInfo({
          page: this.page,
          uid,
          vid: this.vid,
          mid: this.mid,
          token,
        });

        if (!res.data) {
          this.$router.back();
          return;
        }

        const data = res.data;
        if (data.isempty == 2) {
          this.$router.back();
          return;
        }

        this.vid = data.videodata.id;
        this.info = data.videodata;
        localStorage.setItem('vid', this.info.id);
        localStorage.setItem('bid', this.info.bid);

        this.originList = (data.list || []).map(item => ({
          ...item,
          _initialPays: item.pays
        }));
        this.initSwiperData(this.originIndex);
        this.page++;

        this.noteHistoryView();
      } catch (err) {
        console.error(err);
        if (retry < 2) {
          setTimeout(() => this.Recommend(retry + 1), 1000);
        }
      }
    },

    noteHistoryView() {
      const userInfo = this.$getUserInfo();
      if (userInfo) {
        const historyViewParam = {
          vid: this.vid,
          mid: 0,
          uid: userInfo.id,
        };
        historyView(historyViewParam);
      }
    },

    syncUserBalanceFromStorage() {
      const userInfo = this.$getUserInfo ? this.$getUserInfo() : null;
      this.userMoney = Number(userInfo?.money || 0);
    },

    async refreshUserBalance() {
      const userInfo = this.$getUserInfo ? this.$getUserInfo() : null;
      if (!userInfo || !userInfo.id || this.isRefreshingUserBalance) return;

      this.isRefreshingUserBalance = true;

      try {
        const res = await userRInfo({ uid: userInfo.id });
        const data = res?.data;
        if (!data) return;

        this.userMoney = Number(data.money || 0);
        this.$setUserInfo(data);
      } catch (err) {
        console.error('refresh user balance failed', err);
      } finally {
        this.isRefreshingUserBalance = false;
      }
    },

    isEpisodeLocked(episode) {
      return episode && episode.pays == 1;
    },

    openEpisodeBuyPopup(episode = this.originList[this.originIndex]) {
      if (!episode) return;

      this.pauseAndClearAllVideos();
      this.isqp = true;
      this.isPlaying = false;
      this.isBuffering = false;
      this.price = episode.price || 0;
      this.episodePopupVisible = false;
      this.refreshUserBalance();
      this.loadPopupSubscriptions();
      this.buyPopupVisible = true;
    },

    initSwiperData(originIndex) {
      this.destroyPlayer();

      this.currentTime = 0;
      this.duration = 0;
      this.isSeeking = false;
      this.isPlaying = false;
      this.isBuffering = false;
      this.isDragSeeking = false;

      const displayList = new Array(3).fill(null);

      const prevDisplayIndex = this.displayIndex - 1 < 0 ? 2 : this.displayIndex - 1;
      const nextDisplayIndex = this.displayIndex + 1 > 2 ? 0 : this.displayIndex + 1;

      displayList[this.displayIndex] = this.originList[originIndex] || null;

      if (originIndex - 1 >= 0) {
        displayList[prevDisplayIndex] = this.originList[originIndex - 1];
      }

      if (originIndex + 1 < this.originList.length) {
        displayList[nextDisplayIndex] = this.originList[originIndex + 1];
      }

      this.displaySwiperList = displayList;

      this.$nextTick(() => {
        const current = this.displaySwiperList[this.displayIndex];
        if (!current) return;

        if (this.isEpisodeLocked(current)) {
          this.openEpisodeBuyPopup(current);
        } else {
          this.playWithHls(current.src, current.src_srt);
          setTimeout(() => {
            this.isqp = true;
          }, 100);
        }
      });
    },

    decodeProtectedSource(encoded, sourceName = 'media source') {
      if (!encoded) return '';

      try {
        return atob(String(encoded).slice(10, -10));
      } catch (e) {
        console.error(`decode ${sourceName} failed`, e);
        return '';
      }
    },

    async playWithHls(srcEncoded, subtitleEncoded = '') {
      if (!srcEncoded) return;

      const url = this.decodeProtectedSource(srcEncoded, 'video src');
      if (!url) {
        this.isBuffering = false;
        this.isPlaying = false;
        return;
      }

      const videos = this.$refs.videoPlayer;
      if (!videos || !videos.length) {
        console.error('video element not found');
        this.isBuffering = false;
        this.isPlaying = false;
        return;
      }

      const video = videos[this.displayIndex];
      if (!video) {
        this.isBuffering = false;
        this.isPlaying = false;
        return;
      }

      this.videoElement = video;
      this.revokeActiveSubtitleUrl();
      const subtitleToken = this.subtitleLoadToken + 1;
      this.subtitleLoadToken = subtitleToken;
      const subtitleCues = await this.prepareSubtitleTrack(subtitleEncoded);

      if (subtitleToken !== this.subtitleLoadToken || this.videoElement !== video) {
        return;
      }

      this.activeSubtitleCues = subtitleCues;
      this.updateActiveSubtitle(video.currentTime || 0);

      if (subtitleToken !== this.subtitleLoadToken || this.videoElement !== video) {
        this.revokeActiveSubtitleUrl();
        return;
      }

      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }

      this.isBuffering = true;
      this.isPlaying = false;

      const tryAutoplay = () => {
        const playPromise = video.play();

        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(() => {
            this.isPlaying = true;
            this.isBuffering = false;
            this.startSubtitleLoop();
          }).catch(err => {
            console.warn('autoplay blocked', err);
            this.isPlaying = false;
            this.isBuffering = false;
            this.stopSubtitleLoop();
          });
        } else {
          this.isPlaying = !video.paused;
          this.isBuffering = false;
          if (this.isPlaying) {
            this.startSubtitleLoop();
          }
        }
      };

      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url;
        video.load();
        video.onloadedmetadata = () => {
          tryAutoplay();
        };
      } else if (Hls.isSupported()) {
        this.hls = new Hls({
          debug: false,
          enableWorker: true
        });

        this.hls.loadSource(url);
        this.hls.attachMedia(video);

        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          tryAutoplay();
        });

        this.hls.on(Hls.Events.ERROR, (_event, data) => {
          console.error('HLS error', data);
          this.isBuffering = false;
          this.isPlaying = false;
        });
      } else {
        console.error('HLS not supported');
        this.isBuffering = false;
        this.isPlaying = false;
      }
    },

    async prepareSubtitleTrack(subtitleEncoded = '') {
      const subtitleSource = this.decodeProtectedSource(subtitleEncoded, 'subtitle src_srt');

      if (!subtitleSource) return [];

      if (this.isWebVttText(subtitleSource)) {
        return this.parseSubtitleCues(subtitleSource);
      }

      if (this.isSrtText(subtitleSource)) {
        return this.parseSubtitleCues(subtitleSource);
      }

      if (this.isSubtitleUrl(subtitleSource)) {
        try {
          const response = await fetch(subtitleSource);
          const subtitleText = await response.text();
          return this.parseSubtitleCues(subtitleText);
        } catch (error) {
          console.error('load subtitle failed', error);
          return [];
        }
      }

      return this.parseSubtitleCues(subtitleSource);
    },

    isSubtitleUrl(value) {
      return /^https?:\/\//i.test(value) || value.startsWith('/') || value.startsWith('data:');
    },

    isWebVttText(value) {
      return /^\uFEFF?WEBVTT/i.test(String(value).trimStart());
    },

    isSrtText(value) {
      return /\d{2}:\d{2}:\d{2},\d{3}\s*-->\s*\d{2}:\d{2}:\d{2},\d{3}/.test(String(value));
    },

    parseSubtitleCues(subtitleText = '') {
      const text = String(subtitleText)
        .replace(/^\uFEFF/, '')
        .replace(/\r+/g, '')
        .trim();

      if (!text) return [];

      return text
        .split(/\n{2,}/)
        .map(block => this.parseSubtitleBlock(block))
        .filter(Boolean);
    },

    parseSubtitleBlock(block = '') {
      const lines = block
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);
      const timingIndex = lines.findIndex(line => line.includes('-->'));

      if (timingIndex < 0) return null;

      const match = lines[timingIndex].match(
        /((?:\d{2}:)?\d{2}:\d{2}[,.]\d{3})\s*-->\s*((?:\d{2}:)?\d{2}:\d{2}[,.]\d{3})/
      );

      if (!match) return null;

      const text = lines.slice(timingIndex + 1).join('\n');

      if (!text) return null;

      return {
        start: this.parseSubtitleTime(match[1]),
        end: this.parseSubtitleTime(match[2]),
        text
      };
    },

    parseSubtitleTime(value = '') {
      const parts = value.replace(',', '.').split(':');
      const secondsPart = parts.pop() || '0';
      const seconds = Number(secondsPart);
      const minutes = Number(parts.pop() || 0);
      const hours = Number(parts.pop() || 0);

      return (hours * 3600) + (minutes * 60) + seconds;
    },

    updateActiveSubtitle(time) {
      const cue = [...this.activeSubtitleCues]
        .reverse()
        .find(item => time >= item.start && time <= item.end);
      const nextText = cue ? cue.text : '';

      if (nextText !== this.activeSubtitleText) {
        this.activeSubtitleText = nextText;
      }
    },

    syncSubtitleFromVideo(video = this.videoElement) {
      if (!video) return;

      const current = video.currentTime || 0;
      this.currentTime = current;
      this.duration = video.duration || this.duration || 0;
      this.updateActiveSubtitle(current);
    },

    startSubtitleLoop() {
      this.stopSubtitleLoop();

      let lastSyncTime = 0;
      const tick = now => {
        const video = this.videoElement;

        if (!video || video.paused || video.ended) {
          this.subtitleFrameId = null;
          return;
        }

        if (!lastSyncTime || now - lastSyncTime >= 120) {
          this.syncSubtitleFromVideo(video);
          lastSyncTime = now;
        }

        this.subtitleFrameId = window.requestAnimationFrame(tick);
      };

      this.subtitleFrameId = window.requestAnimationFrame(tick);
    },

    stopSubtitleLoop() {
      if (!this.subtitleFrameId) return;

      window.cancelAnimationFrame(this.subtitleFrameId);
      this.subtitleFrameId = null;
    },

    revokeActiveSubtitleUrl() {
      this.subtitleLoadToken += 1;
      this.stopSubtitleLoop();
      this.activeSubtitleCues = [];
      this.activeSubtitleText = '';
    },

    destroyPlayer() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }

      this.pauseAndClearAllVideos();
      this.videoElement = null;
      this.stopSubtitleLoop();

      this.revokeActiveSubtitleUrl();
      this.isBuffering = false;
      this.isDragSeeking = false;
      this.isPlaying = false;
    },

    pauseAndClearAllVideos() {
      const videos = this.$refs.videoPlayer;
      const videoList = Array.isArray(videos) ? videos : (videos ? [videos] : []);

      videoList.forEach(video => {
        if (!video) return;

        try {
          video.pause();
          video.removeAttribute('src');
          video.load();
        } catch (error) {
          console.warn('clear video failed', error);
        }
      });
    },

    togglePlay() {
      const current = this.displaySwiperList[this.displayIndex] || this.originList[this.originIndex];
      if (this.isEpisodeLocked(current)) {
        this.openEpisodeBuyPopup(current);
        return;
      }

      const videos = this.$refs.videoPlayer;
      if (!videos || !videos.length) return;

      const video = videos[this.displayIndex];
      if (!video) return;

      if (video.paused) {
        this.isBuffering = true;

        video.play().then(() => {
          this.isPlaying = true;
          this.isBuffering = false;
          this.startSubtitleLoop();
        }).catch(err => {
          console.warn('play failed', err);
          this.isPlaying = false;
          this.isBuffering = false;
          this.stopSubtitleLoop();
        });
      } else {
        video.pause();
        this.isPlaying = false;
        this.isBuffering = false;
        this.stopSubtitleLoop();
      }
    },

    onLoadedMetadata(e) {
      const video = e.target;
      this.duration = video.duration || 0;
    },

    onTimeUpdate(e) {
      const video = e.target;
      this.syncSubtitleFromVideo(video);
      if (this.isSeeking) return;

      this.isPlaying = !video.paused;
    },

    onSeekInput(e) {
      this.isSeeking = true;
      this.isDragSeeking = true;
      this.currentTime = Number(e.target.value);
      this.updateActiveSubtitle(this.currentTime);
    },

    onSeekChange(e) {
      const videos = this.$refs.videoPlayer;
      if (!videos || !videos.length) {
        this.isSeeking = false;
        this.isDragSeeking = false;
        this.isBuffering = false;
        return;
      }

      const video = videos[this.displayIndex];
      if (!video) {
        this.isSeeking = false;
        this.isDragSeeking = false;
        this.isBuffering = false;
        return;
      }

      const seekTime = Number(e.target.value);

      this.isBuffering = true;
      this.currentTime = seekTime;
      video.currentTime = seekTime;
      this.updateActiveSubtitle(seekTime);

      this.$nextTick(() => {
        this.isSeeking = false;
      });
    },

    onVideoWaiting() {
      this.isBuffering = true;
    },

    onVideoPlaying() {
      this.isBuffering = false;
      this.isPlaying = true;
      this.startSubtitleLoop();
    },

    onVideoPause() {
      this.isPlaying = false;
      this.stopSubtitleLoop();
    },

    onVideoCanPlay() {
      this.isBuffering = false;
    },

    onVideoSeeking() {
      this.isBuffering = true;
    },

    onVideoSeeked() {
      const videos = this.$refs.videoPlayer;
      const videoList = Array.isArray(videos) ? videos : (videos ? [videos] : []);
      const video = videoList[this.displayIndex];

      this.isBuffering = false;
      this.isSeeking = false;
      this.isDragSeeking = false;
      this.syncSubtitleFromVideo(video);
    },

    formatTime(sec) {
      const total = Math.floor(sec || 0);
      const min = Math.floor(total / 60);
      const s = String(total % 60).padStart(2, '0');
      return `${min}:${s}`;
    },

    onVideoError(e) {
      console.error('Video error', e);
      this.isBuffering = false;
      this.isPlaying = false;
    },

    ended() {
      this.stopSubtitleLoop();
      this.activeSubtitleText = '';
      if (!this.hasNextEpisode) return;
      this.switchToNext();
    },

    selectEpisode(epIdx, pays) {
      if (pays == 1) {
        this.originIndex = epIdx;
        this.initSwiperData(this.originIndex);
        this.updateRouteQuery();
      } else {
        this.originIndex = epIdx;
        this.initSwiperData(this.originIndex);
        this.episodePopupVisible = false;
        this.updateRouteQuery();
      }
    },

    ensureLogin() {
      const userInfo = this.$getUserInfo ? this.$getUserInfo() : null;
      if (!userInfo || !userInfo.id) {
        // this.$router.push('/base/login');
        this.$router.push("/user/member/member");
        return null;
      }
      return userInfo;
    },

    formatBalance(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    async goRecharge() {
      if (this.activeMember) return;

      const nextMode = this.packageMode === 'recharge' ? 'vip' : 'recharge';
      await this.switchPopupPackageMode(nextMode);
    },

    async switchPopupPackageMode(mode) {
      if (this.isSubscribing || this.packageMode === mode) return;

      this.packageMode = mode;
      this.selectedSubscriptionId = null;

      if (mode === 'recharge') {
        await this.loadRechargePackages();
      } else {
        await this.loadVipPackages();
      }

      this.ensureDefaultSelectedSubscription();
    },

    async handlePackagePrimaryAction() {
      if (this.activeMember) return;

      if (this.packageMode === 'recharge') {
        await this.rechargeSelectedPackage();
      } else {
        await this.subscribeSelectedPlan();
      }
    },

    async rechargeSelectedPackage() {
      if (this.activeMember) return;

      const userInfo = this.ensureLogin();
      if (!userInfo || this.isSubscribing) return;

      if (!this.popupSubscriptionPlans.length) {
        await this.loadRechargePackages();
        this.ensureDefaultSelectedSubscription();
      }

      const plan = this.selectedPlan || this.popupSubscriptionPlans[0];
      if (!plan) {
        Toast(this.$t('recharge.createOrderFail'));
        return;
      }

      this.selectedSubscriptionId = plan.id;
      this.isSubscribing = true;

      try {
        const res = await buy({
          package_id: plan.id,
          back_url: window.location.href
        });

        if (!res || res.code !== 1) {
          Toast(res?.msg || this.$t('recharge.createOrderFail'));
          return;
        }

        const orderData = res.data || {};
        this.$router.push("/checkout/checkout?order_no=" + orderData.out_trade_no);
      } catch (err) {
        console.error('recharge from detail error:', err);
        Toast(this.$t('recharge.rechargeError'));
      } finally {
        this.isSubscribing = false;
      }
    },

    async subscribeSelectedPlan() {
      if (this.activeMember) return;

      const userInfo = this.ensureLogin();
      if (!userInfo || this.isSubscribing) return;

      if (!this.popupSubscriptionPlans.length) {
        await this.loadVipPackages();
        this.ensureDefaultSelectedSubscription();
      }

      const plan = this.selectedPlan || this.popupSubscriptionPlans[0];
      if (!plan) {
        Toast(this.$t('subscription.empty'));
        return;
      }

      this.selectedSubscriptionId = plan.id;
      this.isSubscribing = true;

      try {
        const res = await buyVip({
          package_id: plan.id,
          back_url: window.location.href
        });

        if (!res || res.code !== 1) {
          Toast(res?.msg || this.$t('video.createSubscriptionOrderFail'));
          return;
        }

        const orderData = res.data || {};
        this.$router.push("/checkout/checkout?order_no=" + orderData.out_trade_no);
      } catch (err) {
        console.error('buyVip from detail error:', err);
        Toast(this.$t('recharge.rechargeError'));
      } finally {
        this.isSubscribing = false;
      }
    },

    choosePopupSubscriptionPlan(plan) {
      if (!plan || this.isSubscribing) return;

      if (this.isSubscriptionPlanDisabled(plan)) {
        Toast(this.$t('subscription.unavailable'));
        return;
      }

      this.selectedSubscriptionId = plan.id;
    },

    buySelectedUnlockOption() {
      if (!this.selectedUnlockOption) {
        Toast(this.$t('video.noDataError'));
        return;
      }

      this.buyUnlockOption(this.selectedUnlockOption);
    },

    async loadPopupSubscriptions() {
      this.packageMode = 'vip';
      await this.loadVipPackages();
      this.ensureDefaultSelectedSubscription();
    },

    async loadVipPackages() {
      if (this.vipPackagesLoaded) return;

      try {
        const res = await getVipPackages({ currency_symbol: this.$t('recharge.currency') });
        if (res && res.code === 1) {
          const data = res.data || [];
          this.vipPackages = Array.isArray(data) ? data : (data.list || []);
          this.vipPackagesLoaded = true;
        }
      } catch (err) {
        console.error('getVipPackages error', err);
      }
    },

    async loadRechargePackages() {
      if (this.rechargePackagesLoaded) return;

      try {
        const res = await rechargeTemp();
        if (res && res.code === 1) {
          const data = res.data || {};
          this.rechargePackages = Array.isArray(data) ? data : (data.list || []);
          this.rechargePackagesLoaded = true;
        }
      } catch (err) {
        console.error('rechargeTemp error', err);
      }
    },

    ensureDefaultSelectedSubscription() {
      if (this.selectedPlan && !this.isSubscriptionPlanDisabled(this.selectedPlan)) return;
      const defaultPlan = this.subscriptionPlans.find(plan => plan.default == 1 && !this.isSubscriptionPlanDisabled(plan));
      const firstAvailablePlan = this.subscriptionPlans.find(plan => !this.isSubscriptionPlanDisabled(plan));
      const targetPlan = defaultPlan || firstAvailablePlan;
      this.selectedSubscriptionId = targetPlan ? targetPlan.id : null;
    },

    formatBillingCycle(cycle) {
      const cycleKeyMap = {
        Weekly: 'video.billingWeekly',
        Monthly: 'video.billingMonthly',
        'Half-Yearly': 'video.billingHalfYearly',
        Yearly: 'video.billingYearly'
      };
      const key = cycleKeyMap[cycle];
      return key ? this.$t(key) : (cycle || this.$t('video.pass'));
    },

    formatSubscriptionPrice(price) {
      const value = Number(price || 0);
      return `Rp ${value.toLocaleString('id-ID')}`;
    },

    getCurrencyText(value) {
      if (!value) return "";
      if (typeof value !== "string") return value;
      try {
        const parsed = JSON.parse(value);
        return parsed["117"] || Object.values(parsed)[0] || "";
      } catch (e) {
        return value;
      }
    },

    isCurrentSubscriptionPlan(plan) {
      return Boolean(plan && plan.is_current == 1);
    },

    isSubscriptionPlanDisabled(plan) {
      if (!plan) return true;
      if (this.isCurrentSubscriptionPlan(plan)) return true;
      if (this.activeMember) return true;
      return this.isSubscribing;
    },

    buildBuyData() {
      const userInfo = this.ensureLogin();
      if (!userInfo) return null;

      const baseData = {
        uid: userInfo.id,
        sid: Number(this.vid),
        order_url: window.location.href,
      };

      const firstEpisodeId = Number(this.originList[this.originIndex]?.id || 0);

      if (!firstEpisodeId) {
        Toast(this.$t('video.noDataError'));
        return null;
      }

      return {
        ...baseData,
        lx: 2,
        img: this.originList[this.originIndex]?.img || this.info.img || '',
        smid: firstEpisodeId
      };
    },

    applyBuySuccess(targetIndex = this.originIndex) {
      const unlockIndex = Number(targetIndex);
      if (!Number.isNaN(unlockIndex) && this.originList[unlockIndex]) {
        this.originIndex = unlockIndex;
        this.$set(this.originList, unlockIndex, {
          ...this.originList[unlockIndex],
          pays: 0
        });
      }

      this.buyPopupVisible = false;
      this.episodePopupVisible = false;
      this.pendingBuyIndex = null;

      this.initSwiperData(this.originIndex);
      this.updateRouteQuery();
    },

    buyUnlockOption() {
      if (this.isBuying) return;

      this.pendingBuyIndex = this.originIndex;

      const data = this.buildBuyData();
      if (!data) {
        this.pendingBuyIndex = null;
        return;
      }
      this.buyRequest(data);
    },

    async buyRequest(data) {
      if (this.isBuying) return;

      this.isBuying = true;

      try {
        const res = await unlockEpisode(data);
        const dataBuy = res.data
        if (dataBuy && dataBuy.is_buy==1) {
            this.applyBuySuccess(this.pendingBuyIndex);
            this.refreshUserBalance();
            Toast(this.$t('video.unlockSuccess'));
          return;
        }

        this.pendingBuyIndex = null;
        Toast(this.$t('video.insufficientBalance') || '余额不足');
      } catch (err) {
        console.error('buy request error', err);
        this.pendingBuyIndex = null;
        Toast(this.$t('video.insufficientBalance') || '余额不足');
      } finally {
        this.isBuying = false;
      }
    },
    goBack() {
      this.$router.back();
    },

    goUser() {
      this.$router.push('/user/member/member');
    },

    toggleFavorite() {
      const userInfo = this.$getUserInfo();
      if (!userInfo) {
        // this.$router.push('/base/login');
        this.$router.push("/user/member/member");
        return;
      }

      const data = {
        vid: this.vid,
      };

      tFavorite(data).then(res => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.info.record = 1;
        } else {
          this.info.record = 2;
        }
      });
    },

    viewEpisode() {
      this.episodePopupVisible = true;
    },
  }
};
</script>

<style scoped>
.video-detail {
  background: #000;
  position: relative;
  overflow: hidden;
}

.header-bar {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.6), transparent);
}

.header-title {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.header-title span {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.swiper-item {
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s;
}

.video-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  object-fit: cover;
}

.subtitle-overlay {
  position: absolute;
  left: 50%;
  bottom: 24%;
  z-index: 19;
  display: inline-block;
  width: auto;
  max-width: min(94vw, 430px);
  max-height: 30vh;
  padding: 0 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.28;
  text-align: center;
  white-space: pre-wrap;
  word-break: normal;
  overflow-wrap: break-word;
  transform: translateX(-50%);
  pointer-events: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.95), 0 0 6px rgba(0, 0, 0, 0.85);
}

/* 中间播放按钮 */
.play-state-layer {
  position: absolute;
  inset: 0;
  z-index: 17;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.play-state-btn {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.play-icon {
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 18px solid #fff;
  margin-left: 4px;
}

/* 中间加载动画 */
.loading-layer {
  position: absolute;
  inset: 0;
  z-index: 18;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.loading-spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.28);
  border-top-color: #fff;
  animation: video-spin 0.8s linear infinite;
  box-sizing: border-box;
}

@keyframes video-spin {
  to {
    transform: rotate(360deg);
  }
}

.video-controls {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 20px;
  z-index: 16;
}

.time-text {
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 12px;
  margin-bottom: 6px;
}

.progress-bar {
  width: 100%;
  height: 4px;
  appearance: none;
  -webkit-appearance: none;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  outline: none;
}

.progress-bar::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.progress-bar::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  border: none;
  cursor: pointer;
}

.userInfo {
  position: absolute;
  right: 10px;
  bottom: 30%;
  z-index: 15;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.btn-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;
}

.img-icon {
  width: 36px;
  height: 36px;
  display: block;
  margin: 0 auto 5px auto;
}

.btn-text {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.contentcd {
  position: absolute;
  bottom: 8%;
  left: 16px;
  z-index: 15;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
}

.words {
  cursor: pointer;
  margin-right: 6px;
}

.popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.popup-content.episode {
  background: #161616;
  border-radius: 20px 20px 0 0;
  width: 100%;
  max-width: 450px;
  padding: 18px 16px 20px;
  color: #fff;
  box-sizing: border-box;
}

.episode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 14px;
}

.episode-header span {
  color: #f4f4f4;
  line-height: 1.2;
}

.episode-header img {
  width: 18px;
  height: 18px;
  opacity: 0.85;
  cursor: pointer;
}

.episode-video-info {
  margin-bottom: 14px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
}

.episode-video-info.no-cover {
  display: block;
}

.info-text {
  min-width: 0;
}

.info-text .title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  color: #fff;
  margin-bottom: 4px;
  word-break: break-word;
}

.info-text .wanji {
  font-size: 11px;
  color: #9f9f9f;
  line-height: 1.3;
}

.episode-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 2px;
}

.episode-list::-webkit-scrollbar {
  width: 4px;
}

.episode-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.16);
  border-radius: 999px;
}

.episode-item {
  position: relative;
  height: 42px;
  border-radius: 12px;
  background: #2a2a2a;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
}

.episode-item:active {
  transform: scale(0.97);
}

.episode-item span {
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  color: #d8d8d8;
}

.episode-item.locked {
  background: #222222;
}

.episode-item.locked span {
  color: #a3a3a3;
}

.episode-item.active {
  background: rgba(255, 180, 79, 0.14);
  border-color: rgba(255, 180, 79, 0.65);
  background-image: none;
}

.episode-item.active span {
  color: #ffb64f;
}

.lock-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 11px;
  height: 11px;
}

.popup-content.buy {
  background: #fff;
  border-radius: 18px 18px 0 0;
  width: 100%;
  max-width: 450px;
  max-height: 84vh;
  overflow-y: auto;
  padding: 10px 12px 14px;
  color: #1f1f1f;
  box-sizing: border-box;
}

.buy-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 4px;
}

.buy-close {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: #f2f3f6;
  color: #7a7f8c;
  font-size: 20px;
  font-weight: 300;
  line-height: 1;
}

.balance-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 52px;
  padding: 7px 10px;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  background: #fafbfc;
}

.balance-left {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.balance-icon {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #fff4cf;
}

.balance-icon img {
  width: 19px;
  height: 19px;
  object-fit: contain;
}

.balance-left span,
.balance-buy-row span {
  display: block;
  color: #9ba0aa;
  font-size: 10px;
  line-height: 1.25;
}

.balance-left strong {
  display: block;
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.1;
}

.recharge-button {
  flex: 0 0 auto;
  min-width: 74px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #f4bd4d, #d9941d);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 5px 12px rgba(218, 151, 31, 0.2);
}

.recharge-button:disabled,
.subscription-action-button:disabled {
  opacity: 0.45;
  box-shadow: none;
  pointer-events: none;
}

.popup-section-title {
  display: flex;
  align-items: center;
  margin: 10px 0 7px;
  color: #20222d;
  font-size: 12px;
  font-weight: 800;
}

.popup-section-title::before {
  content: "";
  width: 3px;
  height: 13px;
  margin-right: 6px;
  border-radius: 999px;
  background: #e4a01c;
}

.popup-subscription-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
}

.popup-subscription-card {
  position: relative;
  min-height: 84px;
  padding: 13px 6px 7px;
  border: 1px solid transparent;
  border-radius: 10px;
  overflow: hidden;
  background: #fafbfc;
  color: #20222d;
  box-sizing: border-box;
  font: inherit;
  text-align: center;
}

.popup-subscription-card.selected {
  border-color: #e4a01c;
  background: #fffdf6;
  box-shadow: 0 0 0 2px rgba(228, 160, 28, 0.08);
}

.popup-subscription-card.disabled {
  opacity: 0.56;
}

.popup-subscription-card:active {
  transform: scale(0.99);
}

.plan-check {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 12px;
  height: 12px;
  border: 1.5px solid #cfd4dc;
  border-radius: 50%;
  box-sizing: border-box;
}

.popup-subscription-card.selected .plan-check {
  border-color: #e4a01c;
  background: #e4a01c;
}

.popup-subscription-card.selected .plan-check::after {
  content: "";
  position: absolute;
  top: 1px;
  left: 3px;
  width: 3px;
  height: 5px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.popup-subscription-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px 6px;
  border-radius: 0 10px 0 8px;
  background: #ff7a2e;
  color: #fff;
  font-size: 7px;
  font-weight: 800;
}

.popup-subscription-card strong {
  display: block;
  margin-top: 11px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
}

.popup-coin-icon {
  width: 11px;
  height: 11px;
  margin-left: 2px;
  vertical-align: -1px;
  object-fit: contain;
}

.popup-subscription-price {
  display: block;
  margin-top: 5px;
  color: #20222d;
  font-size: 14px;
  font-weight: 900;
}

.popup-subscription-status {
  display: inline-flex;
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(47, 143, 78, 0.16);
  color: #2f8f4e;
  font-size: 9px;
  font-weight: 800;
}

.buy-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.balance-buy-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 52px;
  padding: 7px 10px;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  background: #fff;
}

.balance-buy-row strong {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 2px;
  color: #20222d;
  font-size: 17px;
  font-weight: 900;
}

.balance-buy-row strong img {
  width: 16px;
  height: 16px;
}

.balance-buy-row button {
  flex: 0 0 auto;
  min-width: 98px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #4a4d6b, #292d45);
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  box-shadow: 0 6px 14px rgba(44, 48, 72, 0.2);
}

.subscription-action-button {
  width: 100%;
  height: 38px;
  border: 1.5px solid #e4a01c;
  border-radius: 999px;
  background: #fff;
  color: #db9317;
  font-size: 13px;
  font-weight: 900;
}
</style>
